import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/hooks'
import { isCeoUser } from '@/constants/ceo'

/** CEO 白名单路由；admin 不旁路，与 server UserIdGuard 一致 */
export default function RequireCeo() {
  const userId = useAuthStore((s) => s.auth?.user?.id)
  if (!isCeoUser(userId)) return <Navigate to="/403" replace />
  return <Outlet />
}
